<template>
  <b-card>
    <div class="d-flex justify-content-between">
      <div>
        <template v-if="!in_edition">
          <pre v-html="prettified_local_value_dict" />
        </template>
        <template v-else>
          <span> { </span>

          <b-row v-for="(entry, index) in local_value">
            <b-col cols="5">
              <b-form-select
                v-model="local_value[index][0]"
                :options="
                  metavariables_typenames_select_options.concat([
                    {
                      value: local_value[index][0],
                      text: local_value[index][0],
                    },
                  ])
                "
              />
            </b-col>
            <b-col cols="5">
              <b-form-select
                v-model="local_value[index][1]"
                :options="metavariables_possible_values[index]"
              />
            </b-col>
            <b-col cols="2">
              <b-btn
                variant="outline-secondary"
                @click="delete_metavariable(index)"
              >
                <span class="fas fa-trash fa-fw" />
              </b-btn>
            </b-col>
          </b-row>

          <span> } </span>

          <!--  <b-row align-v="end">
            <b-col cols="5">
              <b-form-group class="mb-0">
                <label>
                  <b>{{ $t('metavariable') }}:</b>
                </label>
                <b-form-select
                  v-model="metavariable_typename"
                  :options="metavariables_typenames_select_options"
                />
              </b-form-group>
            </b-col>
            <b-col cols="5">
              <b-form-group class="mb-0">
                <label>
                  <b>{{ $t('value') }}:</b>
                </label>
                <b-form-select
                  v-model="metavariable_value"
                  :options="
                    metavariables_possible_values[
                      metavariables_possible_values.length - 1
                    ]
                  "
                />
              </b-form-group>
            </b-col>
            <b-col cols="2">
              <b-btn variant="outline-secondary" @click="add_metavariable">
                <span class="fas fa-plus fa-fw" />
              </b-btn>
            </b-col>
          </b-row> -->

          <b-row align-v="end">
            <b-col cols="5">
              <b-form-group class="mb-0">
                <label>
                  <b>{{ $t('metavariable_name') }} :</b>
                </label>
                <!--              <b-form-select
                  v-model="metavariable_typename"
                  :options="metavariables_typenames_select_options"
                /> -->
                <b-form-input v-model="metavariable_name" />
              </b-form-group>
            </b-col>
            <b-col cols="5">
              <b-form-group class="mb-0">
                <label>
                  <b>{{ $t('metavariable_type') }} :</b>
                </label>
                <!--              <b-form-select
                  v-model="metavariable_typename"
                  :options="metavariables_typenames_select_options"
                /> -->
                <b-form-select v-model="metavariable_type" />
              </b-form-group>
            </b-col>
            <b-col cols="5">
              <b-form-group class="mb-0">
                <label>
                  <b>{{ $t('value') }} :</b>
                </label>
                <!--              <b-form-select
                  v-model="metavariable_typename"
                  :options="metavariables_typenames_select_options"
                /> -->
                <!-- <b-form-select v-model="metavariable_type" /> -->
                <b-form-input v-model="metavariable_value" />
              </b-form-group>
            </b-col>
            <!--   <b-col cols="5">
              <b-form-group class="mb-0">
                <label>
                  <b>{{ $t('value') }}:</b>
                </label>
                <b-form-select
                  v-model="metavariable_value"
                  :options="
                    metavariables_possible_values[
                      metavariables_possible_values.length - 1
                    ]
                  "
                />
              </b-form-group>
            </b-col> -->
            <b-col cols="2">
              <b-btn variant="outline-secondary" @click="add_metavariable">
                <span class="fas fa-plus fa-fw" />
              </b-btn>
            </b-col>
          </b-row>
        </template>
      </div>
      <div>
        <b-btn
          v-if="is_new_dict"
          @click="validate_edition"
          variant="outline-secondary"
        >
          <span class="fas fa-fw fa-plus" />
        </b-btn>
        <b-btn-group v-else>
          <b-btn @click="toggle_edition" variant="outline-secondary">
            <span
              class="fas fa-fw"
              :class="in_edition ? 'fa-check' : 'fa-pen'"
            />
          </b-btn>
          <b-btn @click="delete_button_on" variant="outline-secondary">
            <span class="fas fa-fw fa-trash" />
          </b-btn>
        </b-btn-group>
      </div>
    </div>
  </b-card>
</template>

<i18n>
{
  "en": {
    "metavariable": "Metavariable",
    "metavariable_name": "Metavariable name",
    "metavariable_type": "Metavariable type",
    "value": "Value"
  },
  "fr": {
    "metavariable": "Métavariable",
    "metavariable_name": "Nom de la métavariable",
    "metavariable_type": "Type de la métavariable",
    "value": "Valeur"
  }
}
</i18n>

<script>
import _ from 'lodash'
import Vue from 'vue'
import draggable from 'vuedraggable'
import { json_syntax_highlight } from '@/utils.js'

// *****************************************************************************

export default {
  name: 'MetavariablesDictElement',
  components: {
    draggable,
  },
  props: ['value', 'metavariables_types', 'in_edition', 'is_new_dict'],

  data() {
    return {
      local_value: undefined,
      // metavariable_typename: '',
      metavariable_name: '',
      metavariable_type: undefined,
      // metavariable_value: undefined,
      metavariable_value: '',
    }
  },

  computed: {
    _() {
      return _
    },

    // metavariables_typenames_select_options() {
    //   let res = _.chain(this.metavariables_types)
    //     .filter(
    //       elt =>
    //         _.indexOf(_.map(this.local_value, val => val[0]), elt.typename) ===
    //         -1
    //     )
    //     .map(elt => {
    //       return { value: elt.typename, text: elt.typename }
    //     })
    //     .value()

    //   return res
    // },

    metavariables_possible_types() {
      let res = [
        { value: 'boolean', text: $t('boolean') },
        { value: 'numeric', text: $t('numeric') },
      ]

      res = res.concat(
        _.map(this.metavariables_types, elt => {
          return { value: elt.typename, text: elt.typename }
        })
      )

      return res
    },
    // metavariables_possible_values() {
    //   let self = this

    //   function possible_values(typename) {
    //     let res = []

    //     let metavariable = _.find(self.metavariables_types, [
    //       'typename',
    //       typename,
    //     ])

    //     if (!_.isUndefined(metavariable)) {
    //       res = metavariable.get_possible_values()
    //     }

    //     return res
    //   }

    //   let res = _.map(this.local_value, elt => possible_values(elt[0]))
    //   res.push(possible_values(this.metavariable_typename))

    //   return res
    // },

    local_value_dict() {
      return Object.fromEntries(this.local_value)
    },

    prettified_local_value_dict() {
      let res = json_syntax_highlight(
        JSON.stringify(this.local_value_dict, null, 2)
      )
      return res
    },
  },

  watch: {
    value: {
      immediate: true,
      handler(nv, ov) {
        if (!_.isEqual(nv, this.local_value)) {
          // this.local_value = _.cloneDeep(nv)
          this.local_value = Object.entries(nv)
        }
      },
    },

    // local_value: {
    //   immediate: true,
    //   handler(nv, ov) {
    //     if (!_.isEqual(nv, ov)) {
    //       this.local_value.sort()
    //     }
    //   },
    // },
  },
  methods: {
    validate_edition() {
      if (!_.isEmpty(this.local_value)) {
        this.$emit('input', this.local_value_dict)
      }
    },

    add_metavariable() {
      this.local_value.push([
        this.metavariable_typename,
        this.metavariable_value,
      ])
      this.metavariable_typename = ''
    },

    delete_metavariable(index) {
      this.local_value.splice(index, 1)
    },

    toggle_edition() {
      if (this.in_edition) {
        this.validate_edition()
      } else {
        this.$emit('start_editing')
      }
    },

    delete_button_on() {
      this.$emit('delete')
    },
  },
}
</script>
